import { Navigate, useLocation, useOutlet } from "react-router-dom";
import { useContextUsuario } from "../contexto/usuario/UsuarioContext";
import { mostraAlertaError } from "../componentes/alerts/sweetAlert";
import { EmpleadoState } from "../contexto/empleado/EmpleadoState";

const normalizePath = (path) => (path.endsWith("/") ? path : path + "/");

const obtenerSubRuta = (rutaActual, rutaBase) =>
  rutaActual.replace(normalizePath(rutaBase), "").split("/")[0] || "";

const tienePermisoRuta = (subRuta, permisos) => {
  const ruta = subRuta.replace(/-/g, " ").trim().toLowerCase();
  return ruta === "" || permisos.map(p => p.trim().toLowerCase()).includes(ruta);
};

export const AdminLayout = () => {
  const outlet = useOutlet();
  const location = useLocation();
  const { usuario } = useContextUsuario();

  if (!usuario || usuario.tipo !== "Empleado") {
    mostraAlertaError("No tienes permitido acceder a este sitio");
    return <Navigate to="/login" />;
  }

  const rutaActual = normalizePath(location.pathname);
  const esRutaLibre = rutaActual.includes("/app/admin/perfil") || rutaActual.startsWith("/app/admin/planillas");
  const accesos = (usuario.accesos || []).filter(a => a.estado === "Activo");

  const acceso = accesos.find(({ ruta }) =>
    rutaActual.startsWith(normalizePath(ruta))
  );

  const primerAcceso = accesos[0];
  const rutaInicio = primerAcceso ? normalizePath(primerAcceso.ruta) : "/app/admin/";

  if (!acceso && !esRutaLibre) {
    mostraAlertaError("No tienes acceso a esta ruta");
    return <Navigate to={rutaInicio} />;
  }

  const subRuta = acceso ? obtenerSubRuta(rutaActual, acceso.ruta) : "";
  const permisos = acceso && acceso.permisos ? acceso.permisos.split(",") : [];

  if (!esRutaLibre && !tienePermisoRuta(subRuta, permisos)) {
    mostraAlertaError("No tienes permiso para acceder a esta sección");
    return <Navigate to={rutaInicio} />;
  }

  return <EmpleadoState>{outlet}</EmpleadoState>;
};
